//#region Util Imports

import * as $ from 'jquery'
import * as _ from 'underscore'

//#endregion

//#region DevExtreme Imports

import DevExpress from 'devextreme'

//#endregion

import { ColumnModel } from '../../../api/api.models'

import { GridOptions, GridController, GridTypes } from '../../../common/grid/grid.controller'
import { MapOptions, Map } from '../../../common/map2/map.directive.controller'

import { IIMRAccordionItem, IMRAccordionItemOptions, IMRAccordionOptions } from '../../../common/accordion'

import { IIMRParameters, IMRParametersOptions, IMRParametersInitializedArgs } from '../../../common/parameters'
import { IDataTypeParametersExtension, IBasicParametersExtension, DataTypeParametersExtension, BasicParametersExtension } from '../../../common/parameters/extensions'

import { IIMRChart, IMRChartOptions } from '../../../common/chart'
import { IMeasureCollectionChartExtension, MeasureCollectionChartExtension } from '../../../common/chart/extensions'

import { GridService } from '../../../../services/grid'

import { IUserSession, TypeHelper, EventsNames, LocalizationHelper, TemplateHelper, ConfigHelper, MapHelper, ToastHelper, ConvertHelper, LogHelper } from '../../../../helpers'
import { OpConsumerTransaction, OpLocation, OpView, OpDevice, OpTariff, OpConsumerPaymentModule, OpTask, OpActionType } from '../../../../models/core'
import { Activity, Enums } from '../../../../models/common'
import { OpMarker, OpConsumerNotificationToSend } from '../../../../models/custom'

import { CashierPanelService, CashierPanelLocationDetailsService } from '../../services'
import { IIMRCashierPanelNewPaymentPopup, IMRCashierPanelNewPaymentPopupOptions } from '../../components'
import { SystemService } from '../../../../services/system'
import { IMRCashierPanelPaymentMode } from '../cashier-panel-new-payment-popup/cashier-panel-new-payment-popup.controller'
import { IMRConfirmationPopupOptions, IMRConfirmationPopupInitializedArgs, IIMRConfirmationPopup } from '../../../common/confirmation-popup2'
import { SourcePopover } from '../../../common/select-box-popup/select-box-popup.directive'
import { LocationService } from '../../../../services/location'
import { ActionRunController } from '../../../common/action-run/action-run.controller'
import { IMRCashierPanelSendNotificationOptions, IIMRCashierPanelSendNotification } from '../cashier-panel-send-notification/cashier-panel-send-notification.interfaces'
import { ConsumerDetailsPaymentsOptions } from '../../../consumers/details/payments'
import { IMRPopupOptions, IIMRPopup, IMRPopupHidingArgs } from '@imr/controls.angularjs/components/overlay/popup'
import { IMRComponentInitializedArgs } from '@imr/controls.angularjs/components/base'


// Public Types

export interface IIMRCashierPanelLocatonDetails {
    setLocation(consumerLocation: OpLocation): void
}

export type IMRCashierPanelLocatonDetailsOptions = {
    onInitialized?(locationDetails: IIMRCashierPanelLocatonDetails): void
    onRefreshRequest?(): void
}

// Public Types End


export class IIMRCashierPanelLocatonDetailsController implements ng.IComponentController, IIMRCashierPanelLocatonDetails {

    // Consts
    private static get LOG_PREFIX(): string { return '[SIMAX.Component.IIMRCashierPanelLocatonDetailsController]' }
    private static get TRANSACTIONS_GRID_NAME(): string { return 'CashierPanelTransactionsGrid' }
    private static get TRANSACTIONS_GRID_DYNAMIC_VALUES_KEY_PREFIX(): string { return 'ct' }

    private get ACTIONS_BUTTON_ID(): string { return 'cashierPanel-actions' }
    private get PREPAID_COMMISSION_DECOMISSION(): { commission: string, decommission: string } {
        return {
            commission: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.PrepaidCommission),
            decommission: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.PrepaidDecommission)
        }
    }

    // Consts End


    // Members

    private isLoading: boolean
    private options: IMRCashierPanelLocatonDetailsOptions

    private consumerLocation: OpLocation

    private newPaymentPopup: IIMRCashierPanelNewPaymentPopup
    private newPaymentPopupOptions: IMRCashierPanelNewPaymentPopupOptions

    private updateOwedPopup: IIMRCashierPanelNewPaymentPopup
    private updateOwedPopupOptions: IMRCashierPanelNewPaymentPopupOptions

    private informationParameters: IIMRParameters<IDataTypeParametersExtension>
    private informationParametersOptions: IMRParametersOptions<IDataTypeParametersExtension>
    private informationAccordionItem: IIMRAccordionItem
    private informationAccordionItemOptions: IMRAccordionItemOptions
    private informationMap: Map
    private informationMapOptions: MapOptions

    private creditAccordionOptions: IMRAccordionOptions

    private currentCreditParameters: IIMRParameters<IBasicParametersExtension>
    private currentCreditParametersOptions: IMRParametersOptions<IBasicParametersExtension>
    private currentCreditAccordionItem: IIMRAccordionItem
    private currentCreditAccordionItemOptions: IMRAccordionItemOptions

    private emergencyCreditParameters: IIMRParameters<IBasicParametersExtension>
    private emergencyCreditParametersOptions: IMRParametersOptions<IBasicParametersExtension>
    private emergencyCreditAccordionItemOptions: IMRAccordionItemOptions

    private measurementsChartAccordionItemOptions: IMRAccordionItemOptions
    private measurementsChart: IIMRChart<IMeasureCollectionChartExtension>
    private measurementsChartOptions: IMRChartOptions<IMeasureCollectionChartExtension>

    private transactionsGridAccordionItemOptions: IMRAccordionItemOptions
    private transactionsGrid: GridController<OpConsumerTransaction>
    private transactionsGridOptions: GridOptions

    private lastPayment: OpConsumerTransaction

    private confirmationPopupOptions: IMRConfirmationPopupOptions
    private confirmationPopup: IIMRConfirmationPopup

    private selectActionPopoverOptions: DevExpress.ui.dxPopoverOptions
    private selectActionPopover: DevExpress.ui.dxPopover

    private cashierActionSelectionListOptions: DevExpress.ui.dxListOptions
    private cashierActionSelectionList: DevExpress.ui.dxList

    private editId: number
    private locationTariffEditOptions: SourcePopover

    private sendNotificationPopupOptions: IMRPopupOptions
    private sendNotificationPopup: IIMRPopup
    private sendNotificationOptions: IMRCashierPanelSendNotificationOptions
    private sendNotificationComponent: IIMRCashierPanelSendNotification

    private notificationText: string
    private notificationToSendData: OpConsumerNotificationToSend

    private paymentModulePopupOptions: IMRPopupOptions
    private consumerDetailsPaymentsOptions: ConsumerDetailsPaymentsOptions
    private paymentModulePopup: IIMRPopup

    private actionButton: DevExpress.ui.dxButton

    // Members End


    // Ctor

    constructor(
        private $scope: ng.IScope,
        private userSession: IUserSession,
        private gridService: GridService,
        private systemService: SystemService,
        private cashierPanelService: CashierPanelService,
        private locationDetailsService: CashierPanelLocationDetailsService,
        private locationService: LocationService
    ) {
        this.editId = new Date().getTime()
    }

    // Ctor End


    // IIMRCashierPanelLocatonDetails Implementation

    public setLocation(location: OpLocation): void {
        this.consumerLocation = location
        this.update()
    }

    // IIMRCashierPanelLocatonDetails Implementation End


    // IComponentController Implementation 

    public $onChanges(changes: { [index: string]: ng.IChangesObject<any> }): void {
        if (TypeHelper.isOptionsDefined(changes)) {
            this.initialize()
        }
    }

    // IComponentController Implementation End


    // Component

    private initialize(): void {
        this.isLoading = true

        if (this.options != null) {

            $.when(
                this.initializeNewPaymentPopup(),
                this.initializeUpdateOwedPopup(),

                this.initializeCreditAccordion(),
                this.initializeCreditParameters(),

                this.initializeInformationAccordion(),
                this.initializeInformationParmeters(),
                this.initializeInformationMap(),

                this.initializeMeasurementsChartAccordion(),
                this.initializeMeasurementsChart(),

                this.initializeTransactionsGridAccordion(),
                this.initializeTransactionsGrid(),

                this.initializeConfirmationPopup(),

                this.initializeSendNotificationPopupOptions(),
                this.initializePaymentModulePopupOptions()
            ).then(() => {
                this.onInitialized()

                this.isLoading = false
            })
        }
    }

    private update(): void {
        this.updateCreditParameters()
        this.updateCreditAccordionItems()

        this.updateInformationParmeters()
        this.updateInformationMap()
        this.updateInformationAccordionItem()

        this.updateMeasurementsChart()
        this.updateTransactionsGrid()

        this.updateNewPaymentPopup()
        this.updateUpdateOwedPaymentPopup()

        this.initializeCashierActionList()

        this.initializeSendNotificationOptions()
        this.initializeConsumerDetailsPaymentsOptions()
    }

    private openLocationDetails(): void {
        if (this.consumerLocation != null) {
            this.systemService.openDetails({
                moduleName: Enums.SimaxModuleName.Location,
                referenceObjectId: this.consumerLocation.idLocation
            })
        }
    }

    // Component End


    // Events

    private onInitialized(): void {
        if (this.options != null && _.isFunction(this.options.onInitialized)) {
            this.options.onInitialized(this)
        }
    }

    private onRefreshRequest(): void {
        if (this.options != null && _.isFunction(this.options.onRefreshRequest)) {
            this.options.onRefreshRequest()
        }
    }

    private onRefreshCredit(): void {
        this.cashierPanelService.refreshCredit(this.consumerLocation.idConsumer, this.consumerLocation.idLocation)
    }

    private submitTopUprollback(): void {
        let idConsumerTransaction: number = null

        if (this.transactionsGrid != null && this.transactionsGrid.selectedItem != null) {
            idConsumerTransaction = this.transactionsGrid.selectedItem.idConsumerTransaction
        }

        this.cashierPanelService
            .topUpRollback(this.consumerLocation.idConsumer, this.consumerLocation.idLocation, idConsumerTransaction)
    }

    // Events End


    // Consumer Information

    private initializeInformationAccordion(): JQueryPromise<void> {
        this.informationAccordionItemOptions = {
            toolbar: {
                disabled: true,
                title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.InformationAboutConsumer),

                items: [{
                    location: 'after',
                    widget: 'dxButton',
                    options: {
                        hint: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ShowLocationDetails),
                        template: TemplateHelper.getIcon(ConfigHelper.Icon.DETAILS, this.userSession),

                        onClick: () => this.openLocationDetails()
                    },
                }],
            },

            onInitialized: (imrAccordionItem: IIMRAccordionItem) => this.informationAccordionItem = imrAccordionItem
        }

        return TypeHelper.onInitializedAll(this.informationAccordionItemOptions)
    }

    private initializeInformationParmeters(): JQueryPromise<void> {
        this.informationParametersOptions = {
            extension: new DataTypeParametersExtension({
                dataType: {
                    dataTypeGroupCategory: Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__LOCATION_PANEL_PARAMS_TO_DISPLAY,
                    moduleName: Enums.SimaxModuleName.Consumer
                },

                useDynamicValues: true,
            }),

            showEmpty: true,

            onInitialized: (e: IMRParametersInitializedArgs<IDataTypeParametersExtension>) => {
                this.informationParameters = e.component
            }
        }

        return TypeHelper.onInitializedAll(this.informationParametersOptions)
    }

    private updateInformationParmeters(): void {
        if (this.informationParameters != null) {
            this.consumerLocation != null ? this.informationParameters.extension.setObject(this.consumerLocation) : this.informationParameters.extension.setObject(null)
            this.informationParameters.refresh()
        }
    }

    private updateInformationAccordionItem(): void {
        if (this.informationAccordionItem != null) {
            this.consumerLocation != null ? this.informationAccordionItem.enableToolbar() : this.informationAccordionItem.disableToolbar()
        }
    }

    // Consumer Information End


    // Credit

    private initializeCreditAccordion(): JQueryPromise<void> {

        this.creditAccordionOptions = {
            onStateRestoring: () => this.cashierPanelService.loadCreditAccordionSettings(),
            onStateStoring: (state: any) => this.cashierPanelService.saveCreditAccordionSettings(state)
        }

        this.currentCreditAccordionItemOptions = {
            expanded: true,

            toolbar: {
                disabled: true,
                title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.CurrentCredit),
                items: this.getToolbarItems()
            },

            onInitialized: (imrAccordionItem: IIMRAccordionItem) => this.currentCreditAccordionItem = imrAccordionItem
        }

        this.emergencyCreditAccordionItemOptions = {
            expanded: true,

            toolbar: {
                title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.EmergencyCredit),
            },
        }

        return TypeHelper.onInitializedAll(this.creditAccordionOptions, this.currentCreditAccordionItemOptions, this.emergencyCreditAccordionItemOptions)
    }

    private getToolbarItems(): DevExpress.ui.dxToolbarItem[] {
        const toolbarItems: DevExpress.ui.dxToolbarItem[] = []

        if (this.userSession.getLoggedOperator().hasPermission(Activity.CONSUMER_SEND_TOP_UP)) {
            const buttonOptions: DevExpress.ui.dxButtonOptions = {
                hint: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NewPayment),
                template: TemplateHelper.getIcon(ConfigHelper.Icon.ADD, this.userSession),

                onClick: () => {
                    if (this.consumerLocation != null) {
                        this.toggleNewPaymentPopup()
                    }
                }
            }

            toolbarItems.push({
                location: 'after',
                widget: 'dxButton',
                options: buttonOptions
            })
        }

        if (this.userSession.getLoggedOperator().hasPermission(Activity.OPERATOR_ALLOW_UPDATE_OWED)) {
            const buttonOptions: DevExpress.ui.dxButtonOptions = {
                hint: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.UpdateOwed),
                template: TemplateHelper.getIcon(ConfigHelper.Icon.DOLLAR, this.userSession),

                onClick: () => {
                    if (this.consumerLocation != null) {
                        this.toggleUpdateOwedPopup()
                    }
                }
            }

            toolbarItems.push({
                location: 'after',
                widget: 'dxButton',
                options: buttonOptions
            })
        }

        if (this.userSession.getLoggedOperator().hasPermission(Activity.ACTION_RUN)) {
            toolbarItems.push({
                location: 'after',
                widget: 'dxButton',
                options: <DevExpress.ui.dxButtonOptions>{
                    hint: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ActionRun),
                    template: TemplateHelper.getIcon(ConfigHelper.Icon.ACTIONS, this.userSession),
                    elementAttr: {
                        id: this.ACTIONS_BUTTON_ID
                    },

                    onInitialized: (e: any) => {
                        this.actionButton = e.component
                    },

                    onClick: () => {
                        if (this.selectActionPopover != null) {
                            if (this.selectActionPopover.option('visible')) {
                                this.selectActionPopover.hide()
                            } else {
                                this.selectActionPopover.show()
                            }
                        }
                    }
                },
            })
        }

        return toolbarItems
    }


    private initializeCreditParameters(): JQueryPromise<void> {
        this.currentCreditParametersOptions = {
            extension: new BasicParametersExtension({
                parameters: this.locationDetailsService.getCurrentCreditParameters(null)
            }),

            showEmpty: true,

            onInitialized: (e: IMRParametersInitializedArgs<IBasicParametersExtension>) => {
                this.currentCreditParameters = e.component
            }
        }

        this.emergencyCreditParametersOptions = {
            extension: new BasicParametersExtension({
                parameters: this.locationDetailsService.getEmergencyCreditParameters(null)
            }),

            showEmpty: true,

            onInitialized: (e: IMRParametersInitializedArgs<IBasicParametersExtension>) => {
                this.emergencyCreditParameters = e.component
            }
        }

        return TypeHelper.onInitializedAll(this.currentCreditAccordionItemOptions, this.emergencyCreditAccordionItemOptions);
    }


    private initializeCashierActionList(): void {
        const selectionOptions = {
            commisionDecommission: '',
            manageValve: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ManageValve),
            changeTariff: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ChangeTariff),
            barButtonItemRefreshCredit: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.RefreshCredit),
            barButtonItemSendTextNotification: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.SendNotification),
            barButtonItemSendImageNotification: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.SendImageNotification), //not used on SGM
            barButtonItemShowManualReadoutHistory: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ShowManualReadoutHistory) //not used for now
        }

        const actionItems: DevExpress.ui.dxListItem[] = []

        let canCommisionDecommission: boolean = false
        const hasPrepadeAvailable: boolean = _.some(this.consumerLocation.currentDevices, (device: OpDevice) => this.cashierPanelService.hasDevicePrepaidAvailable(device))

        if (hasPrepadeAvailable) {

            const isActivePrepaid: boolean = _.some(this.consumerLocation.currentDevices, (device: OpDevice) => this.cashierPanelService.hasDeviceActivePrepaid(device))

            if (isActivePrepaid) {
                canCommisionDecommission = this.cashierPanelService.canOperatorSendDecommission()
                selectionOptions.commisionDecommission = this.PREPAID_COMMISSION_DECOMISSION.decommission
            } else {
                canCommisionDecommission = this.cashierPanelService.canOperatorSendCommission()
                selectionOptions.commisionDecommission = this.PREPAID_COMMISSION_DECOMISSION.commission
            }
        }

        const locationTasks: OpTask[] = null //not used for now //= location != null ? this.userSession.getDataProvider().Task.getTaskFilter(IdLocation: new long[] { location.IdLocation }, IdTaskStatus: new int[] { 2, 3, 4, 5, 7, 8, 9 }, loadNavigationProperties: false, loadCustomData: false) : null; //zadania zweryfikowane, zakonczone i trwające przez montera

        const locationWithActionDevice: boolean = this.cashierPanelService.isLocationWithActionDevice(this.consumerLocation)
        const canChangeTariff: boolean = this.cashierPanelService.canLoggedOperatorChangeDevicePrepaidTariff(this.consumerLocation)

        if (canCommisionDecommission) {
            const commissionDecommissionItem: DevExpress.ui.dxListItem = {
                text: selectionOptions.commisionDecommission
            }

            actionItems.push(commissionDecommissionItem)
        }

        if (locationWithActionDevice
            && this.cashierPanelService.canOperatorManageValve()
            && _.some(this.consumerLocation.currentDevices, (device: OpDevice) => this.cashierPanelService.hasDeviceValve(device))) {
            const manageValveItem: DevExpress.ui.dxListItem = {
                text: selectionOptions.manageValve
            }

            actionItems.push(manageValveItem)
        }

        if (canChangeTariff) {
            const changeTariff: DevExpress.ui.dxListItem = {
                text: selectionOptions.changeTariff
            }

            actionItems.push(changeTariff)
        }

        if (locationWithActionDevice
            && _.some(this.consumerLocation.currentDevices, (device: OpDevice) =>
                this.cashierPanelService.hasDevicePrepaidAvailable(device)
                && this.cashierPanelService.hasDeviceActivePrepaid(device))) {
            const barButtonItemRefreshCredit: DevExpress.ui.dxListItem = {
                text: selectionOptions.barButtonItemRefreshCredit
            }

            actionItems.push(barButtonItemRefreshCredit)
        }

        if (this.consumerLocation != null && this.consumerLocation.idConsumer != null && this.userSession.getLoggedOperator().hasPermission(Activity.OPERATOR_SEND_NOTIFICATION_OP)) {
            const barButtonItemSendTextNotification: DevExpress.ui.dxListItem = {
                text: selectionOptions.barButtonItemSendTextNotification
            }

            actionItems.push(barButtonItemSendTextNotification)
        }

        if (_.size(locationTasks) > 0) {
            const barButtonItemShowManualReadoutHistory: DevExpress.ui.dxListItem = {
                text: selectionOptions.barButtonItemShowManualReadoutHistory
            }

            actionItems.push(barButtonItemShowManualReadoutHistory)
        }

        const hasItems: boolean = _.size(actionItems) > 0

        if (hasItems) {
            this.selectActionPopoverOptions = {
                target: `#${this.ACTIONS_BUTTON_ID}`,
                width: 300,
                onInitialized: e => {
                    this.selectActionPopover = e.component
                }
            }

            this.cashierActionSelectionListOptions = {
                items: actionItems,
                noDataText: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NoData),
                onItemClick: (e: any) => {
                    if (this.selectActionPopover != null) {
                        this.selectActionPopover.hide()
                    }

                    switch (e.itemData.text) {
                        case selectionOptions.commisionDecommission:
                            this.onCommissionDecommissionClick()
                            break
                        case selectionOptions.manageValve:
                            this.onManageValveClick()
                            break
                        case selectionOptions.changeTariff:
                            this.onChangeTariffClick()
                            break
                        case selectionOptions.barButtonItemRefreshCredit:
                            this.onRefreshCreditClick()
                            break
                        case selectionOptions.barButtonItemSendTextNotification:
                            this.onSeendTextNotificationClick()
                            break
                        case selectionOptions.barButtonItemSendImageNotification: //not used on SGM
                            break
                        case selectionOptions.barButtonItemShowManualReadoutHistory: //not used for now
                            break
                    }
                }
            }
        }

        if(this.actionButton != null){
            this.actionButton.option('visible', hasItems)
        }
    }

    private updateCreditParameters(): void {
        if (this.currentCreditParameters != null && this.emergencyCreditParameters != null) {
            if (this.consumerLocation != null) {
                this.currentCreditParameters.extension.setParameters(this.locationDetailsService.getCurrentCreditParameters(this.consumerLocation))
                this.emergencyCreditParameters.extension.setParameters(this.locationDetailsService.getEmergencyCreditParameters(this.consumerLocation))
            }
            else {
                this.currentCreditParameters.extension.setParameters(this.locationDetailsService.getCurrentCreditParameters(null))
                this.emergencyCreditParameters.extension.setParameters(this.locationDetailsService.getEmergencyCreditParameters(null))
            }

            this.currentCreditParameters.refresh()
            this.emergencyCreditParameters.refresh()
        }
    }

    private updateCreditAccordionItems(): void {
        if (this.currentCreditAccordionItem != null) {
            this.consumerLocation != null ? this.currentCreditAccordionItem.enableToolbar() : this.currentCreditAccordionItem.disableToolbar()
        }
    }

    private initializeSendNotificationPopupOptions() {
        this.sendNotificationPopupOptions = {
            innerOptions: {
                title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.SendNotification),
                width: 400,
                height: 450
            },
            bottomToolbarOptions: {
                items: [
                    {
                        location: 'after',
                        widget: 'dxButton',
                        options: {
                            text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Send),
                            hint: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Send),
                            onClick: () => {
                                this.notificationText = this.sendNotificationComponent.notificationMessage
                                this.setNotificationData()
                                this.sendNotification()
                            },
                            disabled: !this.userSession.getLoggedOperator().hasPermission(Activity.OPERATOR_SEND_NOTIFICATION_OP)
                        }
                    }, {
                        location: 'after',
                        widget: 'dxButton',
                        options: {
                            text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Cancel),
                            hint: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Cancel),
                            onClick: () => {
                                this.sendNotificationPopup.hide()
                            },
                            disabled: !this.userSession.getLoggedOperator().hasPermission(Activity.OPERATOR_SEND_NOTIFICATION_OP)
                        }
                    }
                ]
            },
            onInitialized: (e: IMRComponentInitializedArgs<IIMRPopup>) => {
                this.sendNotificationPopup = e.component
            }
        }
    }

    private initializeSendNotificationOptions() {
        if (this.consumerLocation != null) {
            this.sendNotificationOptions = {
                consumer: this.consumerLocation.consumer,
                allowChangeDeliveryType: true,
                onInitialized: (component: IIMRCashierPanelSendNotification) => {
                    this.sendNotificationComponent = component
                }
            }
        }
    }

    private setNotificationData(): void {
        this.notificationToSendData = new OpConsumerNotificationToSend({
            IdConsumer: this.consumerLocation.idConsumer,
            Text: this.notificationText,
            NotificationDeliveryTypes: this.sendNotificationComponent.notificationDeliveryTypes
        })
    }

    private sendNotification(): void {
        this.sendNotificationPopup.toggleLoading(true)

        this.cashierPanelService
            .sendNotification(this.notificationToSendData)
            .then(() => {
                this.sendNotificationPopup.hide()
            })
            .always(() => {
                this.sendNotificationPopup.toggleLoading(false)
            })
    }

    private onManageValveClick(): void {
        let selecteRows: { id: number, name: string }[] = [{ id: this.consumerLocation.idLocation, name: this.consumerLocation.toString() }]

        ActionRunController
            .openActionPopup(this.$scope,
                null,
                this.userSession.getDataProvider(),
                selecteRows,
                Enums.ReferenceType.IdLocation,
                this.editId,
                this.filterActionTypes)
            .fail((error: string) => {
                if (error != null) {
                    ToastHelper.showError(error)
                }
            })
    }

    private filterActionTypes(actionTypes: OpActionType[]): OpActionType[] {
        return _.filter(actionTypes, (actionType: OpActionType) => {
            return (Enums.ActionType.CLOSE_VALVE === actionType.name || Enums.ActionType.OPEN_VALVE_SAFE === actionType.name)
                && actionType.referenceType == Enums.ReferenceType.IdLocation
        })
    }

    // Credit End

    //#region confirmation popup

    private initializeConfirmationPopup(): void {
        this.confirmationPopupOptions = {
            onInitialized: (e: IMRConfirmationPopupInitializedArgs) => {
                this.confirmationPopup = e.component
            }
        }
    }

    private showTopUprollbackConfirmationPopup(): void {
        this.confirmationPopup
            .show({
                title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Confirm),
                content: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.TopUpRollbackQueston),

                onConfirmed: () => {
                    this.submitTopUprollback()
                }
            })
    }

    private showNoPaymentModuleConfirmationPopup(): void {
        this.paymentModulePopup.show()
    }

    private showRefreshCreditConfirmationPopup(): void {
        this.confirmationPopup
            .show({
                title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Confirm),
                content: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.AreYouSureYouWantToRefreshCredit),

                onConfirmed: () => {
                    this.onRefreshCredit()
                }
            })
    }

    private showAssignTariffConfirmationPopup(): void {
        this.confirmationPopup
            .show({
                title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Confirm),
                content: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NoDefinedTariffToLocation),

                onConfirmed: () => {
                    this.onChangeTariffClick()
                }
            })
    }

    private showCommissionConfirmationPopup(): void {
        this.confirmationPopup
            .show({
                title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Confirm),
                content: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.PrepaidCommissionConfirm),

                onConfirmed: () => {
                    this.isLoading = true
                    this.onCommission()
                        .then(() => {
                            this.onRefreshRequest()
                        })
                        .always(() => {
                            this.isLoading = false
                        })
                }
            })
    }

    private showDecommissionConfirmationPopup(): void {
        this.confirmationPopup
            .show({
                title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Confirm),
                content: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.PrepaidDecommissionConfirm),

                onConfirmed: () => {
                    this.isLoading = true
                    this.onDecommission()
                        .then(() => {
                            this.onRefreshRequest()
                        })
                        .always(() => {
                            this.isLoading = false
                        })
                }
            })
    }

    //#endregion

    //#region Map

    private initializeInformationMap(): JQueryPromise<any> {
        const mapDeferred: JQueryDeferred<any> = $.Deferred<any>()

        MapHelper
            .getDefaultOptions(this.userSession.getDataProvider())
            .then((mapOptions: MapOptions) => {
                mapOptions.hideCloseButton = true
                mapOptions.hideCounter = true

                mapOptions.onMapInit = (map: Map) => {
                    this.informationMap = map
                    mapDeferred.resolve()
                }

                this.informationMapOptions = mapOptions
            })

        return mapDeferred.promise()
    }

    private updateInformationMap(): void {
        if (this.informationMap != null) {
            if (this.consumerLocation != null) {
                this.userSession
                    .getDataProvider().View
                    .getActiveView(Enums.ReferenceType.IdLocation)
                    .then((view: OpView) => {
                        const marker: OpMarker = MapHelper.opLocationToOpMarker(this.consumerLocation, { view })

                        if (marker != null) {
                            this.informationMap.setMarkers([marker], false, true)
                        }
                    })
            } else {
                this.informationMap.setMarkers([], false, true)
            }
        }
    }

    //#endregion Map End


    // #region Chart

    private initializeMeasurementsChartAccordion(): JQueryPromise<void> {
        this.measurementsChartAccordionItemOptions = {
            toolbar: {
                visible: false,
            },
        }

        return TypeHelper.onInitializedAll(this.measurementsChartAccordionItemOptions)
    }

    private initializeMeasurementsChart(): JQueryPromise<any> {
        this.measurementsChartOptions = {
            onInitialized: (imrChart: IIMRChart<IMeasureCollectionChartExtension>) => this.measurementsChart = imrChart,
        }

        if (this.userSession.getLoggedOperator().hasPermission(Activity.MEASUREMENTS_LIST)) {
            this.measurementsChartOptions.extension = new MeasureCollectionChartExtension({
                data: {
                    customMeasurementFilter: (idLocationList: number[], serialNbrList: number[], idMeterList: number[], idDataTypeList: number[], dateFrom: Date, dateTo: Date) => {
                        if (this.consumerLocation != null) {
                            return this.userSession
                                .getDataProvider().Consumer
                                .getConsumerMeasurementFilter(this.consumerLocation.idLocation, idDataTypeList, dateFrom, dateTo)
                        }
                    }
                },

                dataTypes: {
                    dataTypeGroupCategory: Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__MEASUREMENTS,
                    simaxModuleName: Enums.SimaxModuleName.Consumer
                },
            }, this.userSession)

            this.measurementsChartOptions.onStateStoring = (state: any) => this.cashierPanelService.saveMeasurmentsChartSettings(state)
            this.measurementsChartOptions.onStateRestoring = () => this.cashierPanelService.loadMeasurmentsChartSettings()
        }

        return TypeHelper.onInitializedAll(this.measurementsChartOptions)
    }

    private updateMeasurementsChart(): void {
        if (this.measurementsChart != null) {
            this.consumerLocation != null ? this.measurementsChart.refresh() : this.measurementsChart.clear()
        }
    }

    // #endregion Chart End


    // #region Grid 

    private initializeTransactionsGridAccordion(): JQueryPromise<void> {
        this.transactionsGridAccordionItemOptions = {
            toolbar: {
                visible: false,
            },
        }

        return TypeHelper.onInitializedAll(this.transactionsGridAccordionItemOptions)
    }

    private initializeTransactionsGrid(): JQueryPromise<any> {

        return this.gridService
            .getColumnModelByCategory(
                [
                    Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__TRANSACTIONS_GRID_PARAMS,
                    Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__TRANSACTIONS_DEFAULT_GRID_PARAMS,
                ],
                Enums.SimaxModuleName.Consumer,
                {
                    prefix: IIMRCashierPanelLocatonDetailsController.TRANSACTIONS_GRID_DYNAMIC_VALUES_KEY_PREFIX
                }
            )
            .then((columns: ColumnModel[], defaultColumns: ColumnModel[]) => {
                this.transactionsGridOptions = {
                    addCustomFilters: true,
                    buttonsOptions: {
                        enabled: true,
                    },
                    columnsDictionary: columns,
                    defaultColumnsDictionary: defaultColumns,
                    idReferenceType: Enums.ReferenceType.IdConsumerTransaction,
                    referenceId: Enums.ReferenceType.IdConsumerTransaction,
                    name: IIMRCashierPanelLocatonDetailsController.TRANSACTIONS_GRID_NAME,
                    type: GridTypes.MAIN,

                    onInitialized: (e: any, gridController: GridController<OpConsumerTransaction>) => this.transactionsGrid = gridController,
                    getDataSource: () => {
                        if (this.consumerLocation != null) {
                            return this.userSession
                                .getDataProvider()
                                .Consumer
                                .getConsumerTransactionFilter(this.consumerLocation.idLocation, null, null)
                                .then((transactions: OpConsumerTransaction[]) => {
                                    const topUpTransactions: OpConsumerTransaction[] = _.filter(transactions, (transaction: OpConsumerTransaction) => transaction.idConsumerTransactionType === Enums.ConsumerTransactionType.TopUp)
                                    this.lastPayment = _.max(topUpTransactions, (transaction: OpConsumerTransaction) => transaction.time)
                                    return transactions
                                })
                        }
                    },
                    contextMenuItems: () => this.getContextMenuItems(),
                    onContextMenuPreparing: (e: any) => {
                        if (this.lastPayment != null) {
                            if (this.transactionsGrid.getSourceObject(e.row.data).idConsumerTransaction === this.lastPayment.idConsumerTransaction) {
                                e.items = this.getContextMenuItems()
                            }
                        }
                    }
                }

                return TypeHelper.onInitializedAll(this.transactionsGridOptions)
            })
    }

    private getContextMenuItems(isTouchScreen: boolean = false): any[] {
        const items: any[] = [];

        if (this.userSession.getLoggedOperator().hasPermission(Activity.ACTION_RUN)) {
            if (this.lastPayment != null
                && this.transactionsGrid.selectedItem != null
                && this.transactionsGrid.selectedItem.idConsumerTransaction === this.lastPayment.idConsumerTransaction
                && this.lastPayment.chargePrepaid > 0) {
                items.push({
                    beginGroup: true,
                    template: TemplateHelper.getContextMenuItem(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.TopUpRollback), ConfigHelper.Icon.UNDO, this.userSession),

                    onItemClick: (e: any) => {
                        this.showTopUprollbackConfirmationPopup()
                    }
                })
            }
        }

        return items
    }

    private updateTransactionsGrid(): void {
        if (this.transactionsGrid != null) {
            this.transactionsGrid.dxGrid.refresh()
        }
    }

    // #endregion Grid End


    //#region New Payment Popup

    private initializeNewPaymentPopup(): void {
        this.newPaymentPopupOptions = {
            onInitialized: (imrNewPaymentPopup: IIMRCashierPanelNewPaymentPopup) => this.newPaymentPopup = imrNewPaymentPopup,
            onPaymentDone: () => this.onRefreshRequest()
        }
    }

    private updateNewPaymentPopup(): void {
        if (this.newPaymentPopup != null) {
            this.newPaymentPopup.setConsumerLocation(this.consumerLocation)
        }
    }

    private toggleNewPaymentPopup(): void {
        if (this.newPaymentPopup != null) {
            this.newPaymentPopup.togglePopup()
        }
    }

    //#endregion New Payment Popup End

    //#region Update Owed

    private initializeUpdateOwedPopup(): void {
        this.updateOwedPopupOptions = {
            onInitialized: (updateOwedPopup: IIMRCashierPanelNewPaymentPopup) => this.updateOwedPopup = updateOwedPopup,
            onPaymentDone: () => this.onRefreshRequest(),
            paymentMode: IMRCashierPanelPaymentMode.UpdateOwed
        }
    }

    private updateUpdateOwedPaymentPopup(): void {
        if (this.updateOwedPopup != null) {
            this.updateOwedPopup.setConsumerLocation(this.consumerLocation)
        }
    }

    private toggleUpdateOwedPopup(): void {
        if (this.updateOwedPopup != null) {
            this.updateOwedPopup.togglePopup()
        }
    }

    //#endregion

    //#region Actions

    //#region Change tariff

    private onChangeTariffClick(): void {
        this.$scope.$broadcast(EventsNames.OPEN_SELECT_POPOVER_POPUP + this.editId, this.getLocationTariffEditOptions())
    }

    private getLocationTariffEditOptions(): SourcePopover {
        this.locationTariffEditOptions = {
            popupTitle: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.SelectTariff),
            selectPopoverSource: {
                referenceTypeId: Enums.ReferenceType.IdTariff,
                selectedId: this.consumerLocation.currentTariff != null ? this.consumerLocation.currentTariff.idTariff : null,
                dictionaryMethod: '',
                dataTypeId: Enums.DataType.HELPER_ID_TARIFF
            },
            allowEmptyValueSubmit: true,
            onSubmit: (idTariffToSave: number) => { this.saveTariff(idTariffToSave) }
        }
        return this.locationTariffEditOptions
    }

    private saveTariff(idTariff: number): void {
        if (idTariff == null && this.consumerLocation.currentTariff == null) {
            return
        }

        this.isLoading = true
        let tariffToSave: OpTariff
        if (idTariff != null) {
            tariffToSave = new OpTariff()
            tariffToSave.opState = Enums.OpChangeState.New
            tariffToSave.idTariff = idTariff
        } else {
            tariffToSave = this.consumerLocation.currentTariff
            tariffToSave.opState = Enums.OpChangeState.Delete
        }

        const locationToSave: OpLocation = new OpLocation(null)
        locationToSave.copy(this.consumerLocation, true, true, false, false)
        locationToSave.currentTariff = tariffToSave
        this.locationService
            .saveLocation(locationToSave, Enums.SimaxModuleName.Tariff)
            .then((savedLocation: OpLocation) => {
                this.onRefreshRequest()
            })
            .fail((error: any) => {
                const errorMessage: string = ConvertHelper.getRequestErrorMessage(error)

                ToastHelper.showError(errorMessage || LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ExceptionOccuredPleaseContactAnAdministrator))
                LogHelper.warn(IIMRCashierPanelLocatonDetailsController.LOG_PREFIX, `Error during tariff change operation.`, error)
            })
            .always(() => {
                this.isLoading = false
            })
    }

    //#endregion

    //#region Seend Text Notification

    private onSeendTextNotificationClick(): void {
        if (this.sendNotificationPopup != null) {
            this.sendNotificationPopup.show()
        }
    }

    //#endregion

    //#region Refresh credit

    private initializePaymentModulePopupOptions(): void {
        this.paymentModulePopupOptions = {
            innerOptions: {
                title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.PaymentModules),
                width: () => window.innerWidth * 0.6,
                minWidth: 600,
                height: () => window.innerHeight * 0.7,
                minHeight: 500
            },
            onInitialized: (e: IMRComponentInitializedArgs<IIMRPopup>) => {
                this.paymentModulePopup = e.component
            },
            onHiding: (e: IMRPopupHidingArgs) => {
                this.paymentModulePopup.toggleLoading(false)
            }
        }

    }

    private initializeConsumerDetailsPaymentsOptions(): void {
        this.consumerLocation.consumer.currentLocation = new OpLocation(null)
        this.consumerLocation.consumer.currentLocation.copy(this.consumerLocation, false, false, true, false)
        this.consumerDetailsPaymentsOptions = {
            idConsumer: this.consumerLocation.idConsumer,
            consumer: this.consumerLocation.consumer
        }
    }

    private onRefreshCreditClick(): void {
        if (this.consumerLocation != null) {
            let consumerPaymentModule: OpConsumerPaymentModule = null

            if (_.size(this.consumerLocation.consumer.paymentModules) > 0) {
                consumerPaymentModule = _.find(this.consumerLocation.consumer.paymentModules, (module: OpConsumerPaymentModule) => {
                    return module.idPaymentModule == Enums.PaymentModule.WebSIMAX
                })
            }

            if (consumerPaymentModule == null || consumerPaymentModule.paymentSystemNumber == null || consumerPaymentModule.paymentSystemNumber.trim() == TypeHelper.emptyString) {
                this.showNoPaymentModuleConfirmationPopup()
                return
            }

            this.showRefreshCreditConfirmationPopup()
        }
    }

    //#endregion

    //#region commission decommission

    private onCommissionDecommissionClick(): void {
        if (_.size(this.consumerLocation.currentDevices) > 0) {
            if (_.some(this.consumerLocation.currentDevices, (device: OpDevice) =>
                this.cashierPanelService.hasDevicePrepaidAvailable(device)
                && !this.cashierPanelService.hasDeviceActivePrepaid(device))) {
                //#region Commission
                if (this.consumerLocation.currentTariff == null) {
                    this.showAssignTariffConfirmationPopup()
                } else {
                    this.showCommissionConfirmationPopup()
                }
                //#endregion
            } else {
                //#region Decommission

                this.showDecommissionConfirmationPopup()

                //#endregion
            }
        }
    }

    private onCommission(): JQueryPromise<void> {
        return this.cashierPanelService.consumerCommission(this.consumerLocation.idConsumer)
    }

    private onDecommission(): JQueryPromise<void> {
        return this.cashierPanelService.consumerDecommission(this.consumerLocation.idConsumer)
    }

    //#endregion

    //#endregion
}


